import { validator } from './schema';
import { executor } from './executor';

export default [validator, executor];
